/**
 * package: com.inq.stage
 * class: ViewportMgrImplBase
 *
 * Base Object of all ViewportMgrImp type objects
 *      Defines base functions which all sub objects will inherit and define itself - polymorphism.
 *
 * This class currently set and unset viewport meta tag.
 *
 * Properties declared
 *      isShown
 *      show()
 *      hide()
 *      uponResize()
 *
 * @constructor
 */
com.inq.stage.ViewportMgrImplBase = function() {
	this.isShown = false;
};
/* Register this base class to $hxClasses object. */
$hxClasses.registerClass(com.inq.stage.ViewportMgrImplBase ,'com.inq.stage.ViewportMgrImplBase');


/** @private @type {boolean} */
com.inq.stage.ViewportMgrImplBase.prototype.isShown = false;


/**
 * hide
 *
 * This resets viewport meta tag content value to its original value from client window.
 *
 * @public
 * @this com.inq.stage.ViewportMgrImplBase
 * @return {void}
 */
com.inq.stage.ViewportMgrImplBase.prototype.hide = function() {
	if(!this.isShown) return;
	this.isShown = false;
};


/**
 * show
 *
 * This sets viewport meta tag content value to an optimized value to open a chat window.
 * A viewport meta tag is created if a client window does not have it.
 *
 * @public
 * @this com.inq.stage.ViewportMgrImplBase
 * @return {void}
 */
com.inq.stage.ViewportMgrImplBase.prototype.show = function() {
	if(this.isShown) return;
	this.isShown = true;
};

/**
 * saveSrollPosition
 *
 * @public
 * @return {Void}
 */
com.inq.stage.ViewportMgrImplBase.prototype.saveScrollPosition = function () {
	this.currentScroll = {X: top.pageXOffset, Y: top.pageYOffset};
};

/**
 * uponResize
 *
 * Declare uponResize member function.
 * - to execute uponResizeAction, this function schedules it and continue listen for resize events.
 *   if a new resize event is detected, cancel previous schedule and schedule it again.
 *   This is to execute uponResizeAction (handler) only once in a series of resize events after the last one.
 *
 * @public
 * @return {void}
 */
com.inq.stage.ViewportMgrImplBase.prototype.uponResize = function() {
};


/**
 * getChatZoomLevel
 *
 * @override
 */
com.inq.stage.ViewportMgrImplBase.prototype.getChatZoomLevel = function() {
	return (window.top.innerWidth / window.top.document.documentElement.offsetWidth);
};


/** @type {com.inq.stage.ViewportMgrImplBase} */
com.inq.stage.ViewportMgrImplBase.prototype.__class__ = com.inq.stage.ViewportMgrImplBase;


